export default "__VITE_ASSET__BVo1Lw0a__"